import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { ContentProviderService } from '../../services/content-provider.service'
import { ExerciseProviderService } from '../../services/exercise-provider.service'

@Component({
  selector: 'app-book',
  templateUrl: './book.page.html',
  styleUrls: ['./book.page.scss'],
})
export class BookPage implements OnInit {

  title: string;
  lection: string;
  content: any;
  exercises: string = "hide";
  id: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public contentProvider: ContentProviderService,
    public exerciseProvider: ExerciseProviderService
  ) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.exercises = params['exercises'];
      if (this.exercises == 'hide'){
        this.exerciseProvider.complete(this.id)
      }
      this.lection = params['lection']
      this.contentProvider.getContent(this.id).then(content => {
        this.content = content;
        this.title = params['title'];
      })
    });
  }

  previous(){
    this.contentProvider.previous(this.id).then(lesson => {
      if (lesson['exercises'] == 'only'){
        this.router.navigate(['/exercises', lesson]);
      } else {
        this.title = lesson['title'];
        this.exercises = lesson['exercises'];
        this.id = lesson['id'];
        this.content = lesson['content'];
      }
    })
  }

  next(){
    this.contentProvider.next(this.id).then(lesson => {
      if (lesson['exercises'] == 'only'){
        this.router.navigate(['/exercises', lesson]);
      } else {
        this.title = lesson['title'];
        this.exercises = lesson['exercises'];
        this.id = lesson['id'];
        this.content = lesson['content'];
      }
    })
  }

  goToExercises(){
    this.router.navigate(['/exercises', {
      'id': this.id,
      exercises: this.exercises,
      lection: this.lection
    }]);
  }

  goToReview(){
    this.router.navigate(['/review', {
      'id': this.id,
      lection: this.lection
    }]);
  }

  goHome(){
    this.router.navigate(['/']);
  }

  ngOnInit() {
  }

}
